import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import useService from '../../../useService';
import { TBulkSegmentFormData } from '../../types';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateBulkSegments } = useService();

	const assignBulkSegments = async (createdData: TBulkSegmentFormData) => {
		try {
			setShowLoader(true);
			requestCreateBulkSegments(createdData).then(
				(res: any) => {
					if (res?.status !== 200) {
						showAlert(res?.data?.error || 'Error occured while uploading bulk segments', { type: 'error' });
						setShowLoader(false);
						history.goBack();
					} else {
						showAlert('Bulk Segments submitted successfully');
						setShowLoader(false);
						history.goBack();
					}
				},
				(err: any) => {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
					setShowLoader(false);
				}
			);
		} catch (error: any) {
			showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: TBulkSegmentFormData) => {
		assignBulkSegments(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
